import { render, staticRenderFns } from "./breadcrumbItem.vue?vue&type=template&id=60398ba5&scoped=true&"
import script from "./breadcrumbItem.vue?vue&type=script&lang=js&"
export * from "./breadcrumbItem.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbItem.vue?vue&type=style&index=0&id=60398ba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60398ba5",
  null
  
)

export default component.exports